export default __webpack_public_path__ + "static/media/info-contract.b7f263ea.jpg";